import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=2ddecc5e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=2ddecc5e&prod&lang=less"
import style1 from "./Register.vue?vue&type=style&index=1&id=2ddecc5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddecc5e",
  null
  
)

export default component.exports